import React, { useEffect } from 'react';
import styles from '../static/styles/LearnWin.module.css';
import gamezAcad1 from '../static/img/LearnWin/gamezAcad_1.avif';
import gamezAcad2 from '../static/img/LearnWin/gamezAcad_2.avif';
import gamezAcad3 from '../static/img/LearnWin/gamezAcad_3.avif';

const LearnWin = () => {
  const learnWinImages = [gamezAcad1, gamezAcad2, gamezAcad3];

  useEffect(() => {
    document.title = "Learn & Win | Ufone ESG"
  }, [])

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>Learn & Win</h1>
      <p className={styles.subheading}>Test your gaming mettle</p>
      <div className={styles.grid}>
        {learnWinImages.map((image, index) => (
          <div
            key={index}
            className={styles.card}
            onClick={() => window.open('https://gamezacademy.pk/', '_blank')}
            style={{ cursor: 'pointer', backgroundImage: `url(${image})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
          >
          </div>
        ))}
      </div>
    </div>
  );
};

export default LearnWin;
